import React, { useState } from "react";
import "../../css/Bonus.css";

function Bonus({ enigme = "la-gardienne-du-temps" }) {
    const enigmas = {
        "la-gardienne-du-temps": [
            { src: "/img/Bonus/ches.jpg", alt: "L'avenir", className: "bonus_2" },
            { src: "/img/Bonus/je-ne-sers-pas-pour-l-autre-enigme-hihi.jpg", alt: "L'avenir 2", className: "bonus_3" },
            { src: "/img/Bonus/toutes.jpg", alt: "La gardienne du temps", className: "bonus_1" },
            { src: "/img/Bonus/les.jpg", alt: "L'ascension", className: "bonus_1" },
            { src: "/img/Bonus/4.jpg", alt: "L'inversion", className: "bonus_1" },
            { src: "/img/Bonus/mar.jpg", alt: "Baryon", className: "bonus_1" },
            { src: "/img/Bonus/lettre.jpg", alt: "Alphabet", className: "bonus_1" },
        ],
        "solstice-des-glaces": [
            { src: "/img/Bonus/solstice_finale.jpg", alt: "Total", className: "full_e_bonus" },
        ],
    };

    const [activeEnigma, setActiveEnigma] = useState(enigme);
    const [activeImage, setActiveImage] = useState(enigmas[enigme][0]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleEnigmaChange = (enigma) => {
        setActiveEnigma(enigma);
        setActiveImage(enigmas[enigma][0]);
    };

    const handleButtonClick = (image) => {
        if (activeImage.alt !== image.alt) {
            setActiveImage(image);
        }
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div>
            <div className="espaceHaut"></div>
            <div className="fondParchemin">
                <h1>Énigme Passe Temps</h1>
                <h2>Règles du jeu</h2>
                <ul>
                    <li>Une énigme c'est : un texte et une illustration associée.</li>
                    <li>Ce sont des énigmes originales créées spécialement pour l'événement, il n'y a donc aucun risque de spoils des livres.</li>
                    <li>Tout est fait avec amour et arrachage de cheveux pour le passe temps.</li>
                    <li>L'équipe du Passe-Temps a le droit à 5 indices.</li>
                    <li>Si vous pensez avoir trouvé la clef finale, on est là pour entendre vos solutions les plus farfelues.</li>
                    <li>Vous avez le droit de jouer à 5000 en même temps, c'est un jeu collaboratif.</li>
                    <li>Le niveau de difficulté est assez corsé et globalement représentatif de ce que l'on trouve dans le livre.</li>
                    <li>Nous vous recommandons d'utiliser un ordinateur plutôt qu'un téléphone portable.</li>
                </ul>
            </div>

            <div className="enigmas-buttons button-container">
                <button
                    className={`enigma-button ${activeEnigma === "la-gardienne-du-temps" ? "active" : ""}`}
                    onClick={() => handleEnigmaChange("la-gardienne-du-temps")}
                >
                    L’énigme 1 : la-gardienne-du-temps
                </button>
                <button
                    className={`enigma-button ${activeEnigma === "solstice-des-glaces" ? "active" : ""}`}
                    onClick={() => handleEnigmaChange("solstice-des-glaces")}
                >
                    L’énigme 2 : solstice-des-glaces
                </button>
            </div>

            <div className="button-container">
                {enigmas[activeEnigma].map((image) => (
                    <button
                        key={image.alt}
                        className={`image-button ${activeImage.alt === image.alt ? "active" : ""} ${image.className}`}
                        onClick={() => handleButtonClick(image)}
                        disabled={activeImage.alt === image.alt}
                    >
                        {image.alt}
                    </button>
                ))}
            </div>

            <div className="image-container text-center">
                <img
                    src={activeImage.src}
                    alt={activeImage.alt}
                    className={`img_${activeImage.className}`}
                    style={{ maxWidth: "90vw", maxHeight: "90vh", height: "auto" }}
                    onClick={toggleModal}
                />
            </div>

            {isModalOpen && (
                <div className="modal" onClick={toggleModal}>
                    <div className="modal-content">
                        <img src={activeImage.src} alt={activeImage.alt} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Bonus;
